const GoodPagesIds = ['dashboard'];

export default GoodPagesIds;
